<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <h2 class="purple bold">Faltas e presenças</h2>
      </b-col>

      <b-col>
        <div class="attendance-actions">
          <b-button @click="openModalAttClass" class="purple primary"
            >Marcar presença na turma</b-button
          >
          <b-button
            class=" blue"
            :to="{
              name: redirectToCorrectUrl('registrar-faltas-presencas'),
            }"
            >Adicionar novo</b-button
          >
        </div>
      </b-col>
    </b-row>

    <b-row class="mb-5">
      <b-col>
        <div class="attendance-actions">
          <b-button
            class="blue outline report-btn"
            :disabled="generatingReport"
            @click="generateReport"
            >{{
              generatingReport ? "Gerando relatório..." : "Exportar Relatório"
            }}</b-button
          >
          <b-button
            class="blue outline report-btn"
            :disabled="generatingReportAudit"
            @click="generateReportAudit"
            >{{
              generatingReportAudit
                ? "Gerando relatório..."
                : "Exportar Relatório Auditoria"
            }}</b-button
          >
          <b-button
            class="blue outline report-btn"
            :disabled="!cycle || downloadingAbsenceLimitReport"
            @click="downloadAbsenceLimitReport"
            >{{
              downloadingAbsenceLimitReport
                ? "Gerando relatório..."
                : "Exportar Relatório de Limite de Faltas"
            }}</b-button
          >
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="3">
        <SelectCycles
          v-model="cycle"
          :callback="callbackCycles"
          label="Ciclo"
          :selected="cycle"
        />
        <span
          class="clear-field"
          v-if="hasActiveFilters"
          @click="clearFields"
          >Limpar filtros</span
        >
      </b-col>

      <b-col md="3">
        <b-form-group label="Turmas">
          <multiselect
            v-model="classroom"
            :options="classrooms"
            placeholder="Selecione"
            label="designation"
            track-by="id"
            selectLabel=""
            @select="callbackClassrooms"
            @remove="callbackRemoveClassrooms"
          >
            <span slot="noResult">Nada encontrado</span>
          </multiselect>
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group class="calendar">
          <label>De</label>
          <Datepicker
            v-model="startDateFilter"
            placeholder="Selecione"
            format="dd/MM/yyyy"
            :use-utc="true"
            :language="languages[language]"
            @selected="callbackStartDateFilter"
          >
          </Datepicker>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group class="calendar">
          <label>Até</label>
          <Datepicker
            v-model="endDateFilter"
            placeholder="Selecione"
            format="dd/MM/yyyy"
            :use-utc="true"
            :language="languages[language]"
            @selected="callbackEndDateFilter"
          >
          </Datepicker>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col md="3">
        <SelectAttendances
          v-model="attendance"
          showLabel="true"
          placeholder="Selecione"
          :callback="callbackAttendances"
        />
      </b-col>

      <b-col md="3">
        <b-form-group label="Local do registro">
          <multiselect
            v-model="registerPlace"
            :options="qrcodeUsers"
            :multiple="false"
            placeholder="Selecione"
            label="name"
            track-by="id"
            selectLabel=""
            @select="callbackAttendancesPlaces"
          >
            <span slot="noResult">Nada encontrado</span>
          </multiselect>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Buscar">
          <b-input-group-prepend>
            <b-form-input
              type="search"
              placeholder="Nome ou Matrícula do aluno"
              v-model="searchTitle"
              v-on:keyup.enter="
                page = 1;
                getAttendanceList();
              "
            ></b-form-input>
            <b-input-group-text
              class="clear-fields"
              v-if="searchTitle != ''"
              v-b-tooltip.hover
              title="Limpar Pesquisa"
            >
              <b-icon icon="x" @click="clearSearchTitle" />
            </b-input-group-text>
          </b-input-group-prepend>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row style="margin-top: 20px">
      <b-col>
        <b-container fluid>
          <b-row
            class="header-list-teacher"
            v-if="attendances.length > 0 && isRequestSend"
          >
            <b-col md="3" class="d-flex justify-content-center">
              <p class="bold text-center">Aluno</p>
            </b-col>
            <b-col md="1" class="d-flex justify-content-center">
              <p class="bold text-center">Turma</p>
            </b-col>
            <b-col md="2" class="d-flex justify-content-center">
              <p class="bold text-center">Evento</p>
            </b-col>
            <b-col md="1" class="d-flex justify-content-center">
              <p class="bold text-center">Tipo</p>
            </b-col>
            <b-col md="2" class="d-flex justify-content-center">
              <p class="bold text-center">Data e Hora</p>
            </b-col>
            <b-col md="1" class="d-flex justify-content-center">
              <p class="bold text-center">Local/Usuário</p>
            </b-col>
            <b-col
              md="2"
              class="d-flex justify-content-center"
              style="padding-right: 30px"
            >
              <p class="bold" style="display: inline-block">Ações</p>
            </b-col>
          </b-row>
        </b-container>

        <b-container fluid>
          <b-row
            align-v="center"
            class="list-teacher"
            v-for="attendance in attendances"
            v-bind:key="attendance.id"
          >
            <b-col md="3" class="d-flex justify-content-center">
              <router-link
                :to="{
                  name: 'perfil-aluno',
                  params: {
                    id: attendance.student_id,
                  },
                }"
                target="_blank"
              >
                <p class="text-center" v-if="attendance.student_user_name">
                  {{ attendance.student_user_name }}
                </p>
              </router-link>
            </b-col>
            <b-col
              md="1"
              class="d-flex justify-content-center align-items-center"
            >
              <router-link
                :to="{
                  name: 'perfil-turma',
                  params: {
                    id: attendance.classroom_id,
                  },
                }"
                target="_blank"
              >
                <p class="text-center">
                  <span
                    class="classroom"
                    :class="{ 'old-classroom': attendance.is_different_classroom }"
                    v-b-tooltip.hover
                    :title="
                      attendance.is_different_classroom
                        ? 'Aluno(a) trocado de turma'
                        : ''
                    "
                  >
                    {{ attendance.classroom_designation }}
                  </span>
                </p>
              </router-link>
            </b-col>

            <b-col md="2" class="d-flex justify-content-center">
              <p class="text-center">
                <span
                  class="attendance"
                  :class="{
                    absence: attendance.type === 'absence' ? 'absence' : '',
                    presence: attendance.type === 'presence' ? 'presence' : '',
                    late: attendance.type === 'late' ? 'late' : '',
                    antecipated:
                      attendance.type === 'antecipated' ? 'antecipated' : '',
                    regular_leave:
                      attendance.type === 'regular_leave'
                        ? 'regular_leave'
                        : '',
                  }"
                >
                  {{
                    attendance.type === "absence"
                      ? "Falta"
                      : "" || attendance.type === "presence"
                      ? "Presença"
                      : "" || attendance.type === "late"
                      ? "Chegada Tardia"
                      : "" || attendance.type === "antecipated"
                      ? "Saída Antecipada"
                      : "" || attendance.type === "regular_leave"
                      ? "Saída Regular"
                      : ""
                  }}
                </span>
              </p>
            </b-col>

            <b-col md="1" class="d-flex justify-content-center">
              <p style="font-size: 17px" class="text-center">
                {{
                  attendance.period === "regular"
                    ? "Horário regular"
                    : "Contraturno"
                }}
              </p>
            </b-col>

            <b-col md="2" class="d-flex justify-content-center">
              <p class="text-center">
                {{ attendance.date }}
              </p>
            </b-col>

            <b-col md="1" class="d-flex justify-content-center">
              <p class="text-center">
                {{
                  attendance.origin === "job"
                    ? "Automático"
                    : attendance.token_user_name
                    ? attendance.token_user_name
                    : "Usuário inválido"
                }}
              </p>
            </b-col>

            <b-col md="2" class="action-btns d-flex justify-content-center">
              <router-link
                :to="{
                  name: redirectToCorrectUrl('visualizar-faltas-presencas'),
                  params: {
                    id: attendance.id,
                  },
                }"
              >
                <ViewIcon />
              </router-link>

              <router-link
                :to="{
                  name: redirectToCorrectUrl('editar-faltas-presencas'),
                  params: {
                    id: attendance.id,
                  },
                }"
              >
                <EditIcon />
              </router-link>

              <a v-on:click.prevent="exclude(attendance.id)">
                <DeleteIcon />
              </a>
            </b-col>
          </b-row>
          <b-row
            align-v="center"
            class="list-teacher"
            v-if="attendances.length <= 0 && isRequestSend"
          >
            <b-col class="d-flex justify-content-center text-center"
              >Nenhum resultado encontrado</b-col
            >
          </b-row>
          <b-row align-v="center" class="list-teacher" v-if="!isRequestSend">
            <b-col class="d-flex justify-content-center text-center"
              >Carregando</b-col
            >
          </b-row>
          <b-row
            class="align-center"
            v-else-if="count > perPage && isRequestSend"
          >
            <b-pagination
              v-model="page"
              :per-page="perPage"
              :total-rows="count"
              @change="changePage"
              aria-controls="teachersList"
              last-text
              first-text
            >
              <template #prev-text>
                <LeftArrowIcon class="left" />
              </template>
              <template #next-text>
                <LeftArrowIcon />
              </template>
            </b-pagination>
          </b-row>
        </b-container>
      </b-col>
    </b-row>

    <b-modal
      id="modal-att-class"
      title="Marcar presença para turma"
      size="xl"
      hide-footer
    >
      <b-row>
        <b-col md="2">
          <b-form-group label="Turmas">
            <multiselect
              v-model="classroomModal"
              :options="classrooms"
              :multiple="true"
              placeholder="Selecione"
              label="designation"
              track-by="id"
              selectLabel=""
              @select="callbackClassroomsModal"
              @remove="callbackRemoveClassroomsModal"
            >
              <span slot="noResult">Nada encontrado</span>
            </multiselect>
          </b-form-group>
          <span class="clear-field" @click="clearFieldsModal"
            >Limpar filtros</span
          >
        </b-col>
        <b-col md="2">
          <b-form-group class="calendar">
            <label>Data da presença</label>
            <Datepicker
              v-model="attendanceDate"
              placeholder="Selecione"
              format="dd/MM/yyyy"
              :use-utc="true"
              :language="languages[language]"
            >
            </Datepicker>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <StandardInput
            v-model="timeModal"
            type="time"
            name="designation"
            label="Hora"
          >
          </StandardInput>
        </b-col>
        <b-col md="2">
          <SelectAttendances
            v-model="geralTypeModal"
            placeholder="Selecione"
            :showLabel="true"
            label="Evento"
            :disabled="studentsModal.length <= 0"
            :callback="callbackGeraltEventModal"
          />
        </b-col>
        <b-col md="2">
          <SelectSimple
            label="Tipo"
            v-model="generalPeriodModel"
            :disabled="studentsModal.length <= 0"
            :options="[
              { id: 'regular', label: 'Horário regular' },
              { id: 'after_hour', label: 'Contraturno' },
            ]"
            :callback="callbackGeraltTypeModal"
          />
        </b-col>
        <b-col md="1">
          <b-form-group class="label-add" :label="'&nbsp;'">
            <b-button
              :disabled="
                !attendanceDate ||
                !timeModal ||
                !geralTypeModal ||
                !generalPeriodModel ||
                selectedClassroomsModal.length <= 0 ||
                studentsModal.length <= 0
              "
              @click="submitAllStudents"
              class="blue"
              >Registrar</b-button
            >
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col style="margin-top: 15px" md="12">
          <h2>Alunos</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-container fluid>
            <b-row class="header-list-teacher" v-if="studentsModal.length > 0">
              <b-col class="d-flex justify-content-center">
                <p class="bold text-center">Matrícula</p>
              </b-col>
              <b-col md="3" class="d-flex justify-content-center">
                <p class="bold text-center">Nome</p>
              </b-col>
              <b-col class="d-flex justify-content-center">
                <p class="bold text-center">Tipo</p>
              </b-col>
              <b-col class="d-flex justify-content-center">
                <p class="bold text-center">Período</p>
              </b-col>
              <b-col class="d-flex justify-content-center">
                <p class="bold text-center"></p>
              </b-col>
            </b-row>
          </b-container>
          <b-container fluid>
            <b-row
              align-v="center"
              class="list-teacher"
              v-for="(student, index) in studentsModal"
              v-bind:key="index"
            >
              <b-col class="d-flex justify-content-center">
                <p class="text-center">{{ student.student_id }}</p>
              </b-col>
              <b-col md="4" class="d-flex justify-content-center">
                <p class="text-center">
                  {{ student ? student.name : "Nome não cadastrado" }}
                </p>
              </b-col>
              <b-col class="d-flex justify-content-center">
                <SelectAttendances
                  v-model="student.type"
                  placeholder="Selecione"
                  :callback="(value) => callbackAttendancesModal(value, index)"
                />
              </b-col>
              <b-col class="d-flex justify-content-center">
                <SelectSimple
                  v-model="student.period"
                  :options="[
                    { id: 'regular', label: 'Horário regular' },
                    { id: 'after_hour', label: 'Contraturno' },
                  ]"
                  :callback="callbackAttendances"
                />
              </b-col>
              <b-col class="d-flex justify-content-center">
                <a
                  style="display: flex; justify-content: center"
                  v-on:click.prevent="studentsModal.splice(index, 1)"
                >
                  <DeleteIcon />
                </a>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row v-if="!studentsModal.length > 0">
        <b-col md="12" class="d-flex justify-content-center">
          <p v-if="studentsModal.length <= 0" class="text-center">
            Nenhum resultado encontrado
          </p>
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import DataService from "@/services/attendances.service";
import DataServiceClassrooms from "@/services/classrooms.service";
import SelectAttendances from "@/components/inputs/SelectAttendances.vue";
import SelectCycles from "@/components/inputs/SelectCycles.vue";
import LeftArrowIcon from "@/components/svg/LeftArrowIcon.vue";
import ViewIcon from "@/components/svg/ViewIcon.vue";
import EditIcon from "@/components/svg/EditIcon.vue";
import DeleteIcon from "@/components/svg/DeleteIcon.vue";
import moment from "moment-timezone";
import httpRda from "../../../http-rda";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import SelectSimple from "@/components/inputs/SelectSimple.vue";
import StandardInput from "@/components/inputs/StandardInput.vue";
import { mapGetters } from "vuex";

const ATTENDANCE_OPTIONS = [
  { id: "1", value: "presence", name: "Presença" },
  { id: "2", value: "regular_leave", name: "Saída Regular" },
  { id: "3", value: "antecipated", name: "Saída Antecipada" },
  { id: "4", value: "late", name: "Chegada Tardia" },
  { id: "5", value: "absence", name: "Falta" },
];

export default {
  name: "faltas-presencas",
  components: {
    SelectAttendances,
    SelectCycles,
    LeftArrowIcon,
    ViewIcon,
    EditIcon,
    DeleteIcon,
    Datepicker,
    SelectSimple,
    StandardInput,
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/getAuthData",
    }),
    resolvedRegisterPlace() {
      if (this.registerPlace == null) {
        return undefined;
      }

      if (Number.isInteger(this.registerPlace)) {
        return this.registerPlace;
      }

      return this.registerPlace.id;
    },
    hasActiveFilters() {
      return (
        this.cycle != null ||
        this.selectedClassrooms != null ||
        this.attendance != null ||
        this.registerPlace != null ||
        this.startDateFilter != null ||
        this.endDateFilter != null ||
        this.searchTitle != ""
      );
    },
  },

  data() {
    return {
      attendances: [],
      classrooms: [],
      registerPlace: null,
      filecsv: null,
      qrcodeUsers: [],
      paramsReport: {},

      descOrder: false,
      isRequestSend: false,

      cycle: null,
      downloadingAbsenceLimitReport: false,
      generatingReport: false,
      generatingReportAudit: false,
      classroom: null,
      selectedClassrooms: null,
      classroomModal: [],
      selectedClassroomsModal: [],
      attendance: null,
      searchTitle: "",

      isInternalNavigation: false,
      page: 1,
      count: 0,
      startDateFilter: null,
      endDateFilter: null,
      perPage: 20,

      studentsModal: [],
      attendanceDate: null,
      timeModal: moment().format("HH:mm").toString(),
      geralTypeModal: {
        id: "presence",
        value: "presence",
        name: "Presença",
      },
      generalPeriodModel: {
        id: "regular",
        label: "Horário regular",
      },

      breadcrumb: [
        {
          text: "Secretaria",
          href: "/secretaria",
        },
        {
          text: "Faltas e presenças",
          active: true,
        },
      ],

      language: "ptBR",
      languages: lang,
    };
  },

  filters: {
    date(date) {
      try {
        return moment(date).format("DD/MM/YYYY");
      } catch (error) {
        return date;
      }
    },
  },

  methods: {
    callbackStartDateFilter(date) {
      const currentTzOffset = Math.abs(moment().utcOffset() / 60);
      this.startDateFilter = moment(date)
        .add("day", currentTzOffset > 0 ? 1 : 0)
        .format("YYYY-MM-DD")
        .toString();
      this.page = 1;

      this.getAttendanceList();
    },

    callbackEndDateFilter(date) {
      const currentTzOffset = Math.abs(moment().utcOffset() / 60);
      this.endDateFilter = moment(date)
        .add("day", currentTzOffset > 0 ? 1 : 0)
        .format("YYYY-MM-DD")
        .toString();
      this.page = 1;

      this.getAttendanceList();
    },

    openModalAttClass() {
      this.$bvModal.show("modal-att-class");
    },

    getRequestParams(
      searchTitle,
      page,
      perPage,
      attendance,
      classroom,
      startDate,
      endDate,
      registerPlace,
      cycle
    ) {
      let params = {};

      if (startDate) {
        params["startDate"] = moment(startDate)
          .add("hours", 4)
          .format("YYYY-MM-DD");
      }

      if (endDate) {
        params["endDate"] = moment(endDate)
          .add("hours", 4)
          .format("YYYY-MM-DD");
      }

      if (searchTitle) {
        params["name"] = searchTitle;
      }

      if (page) {
        params["page"] = page;
      }

      if (perPage) {
        params["limit"] = perPage;
      }

      if (attendance) {
        params["type"] = attendance.value;
      }

      if (classroom) {
        params["students_classroom_id"] = classroom;
      }

      if (registerPlace) {
        params["register_place"] = registerPlace;
      }

      if (cycle) {
        params["cycle_id"] = cycle;
      }

      return params;
    },

    getAttendanceList() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page,
        this.perPage,
        this.attendance,
        this.selectedClassrooms,
        this.startDateFilter,
        this.endDateFilter,
        Number.isInteger(this.registerPlace)
          ? this.registerPlace
          : this.registerPlace?.id || null,
        this.cycle
      );

      this.paramsReport = {
        classroom_id: this.selectedClassrooms,
        date_start: this.startDateFilter ? this.startDateFilter : null,
        date_end: this.endDateFilter ? this.endDateFilter : null,
      };

      this.isInternalNavigation = true;

      this.$router
        .replace({
          query: {
            search: this.searchTitle || undefined,
            page: this.page,
            attendance: this.attendance ? this.attendance.value : undefined,
            classrooms: this.selectedClassrooms
              ? String(this.selectedClassrooms)
              : undefined,
            startDate: this.startDateFilter || undefined,
            endDate: this.endDateFilter || undefined,
            registerPlace: this.resolvedRegisterPlace,
            cycle: this.cycle || undefined,
          },
        })
        .catch(() => {});

      this.$nextTick(() => {
        this.isInternalNavigation = false;
      });

      DataService.getAll(params)
        .then((response) => {
          this.attendances = response.data.attendances;
          this.count = response.data.count;
          this.isRequestSend = true;

          this.attendances.map((attendance) => {
            if (attendance.type === "absence") {
              attendance.date = moment(
                attendance.date,
                "DD/MM/YYYY HH:SS"
              ).format("DD/MM/YYYY");
            }

            return attendance;
          });
        })
        .catch((error) => {
          return error.data;
        });
    },

    syncFiltersFromQuery() {
      const query = this.$route.query;

      this.searchTitle = query.search || "";
      this.page = Number(query.page) || 1;
      this.cycle = query.cycle ? Number(query.cycle) : null;

      if (query.attendance) {
        const found = ATTENDANCE_OPTIONS.find(
          (o) => o.value === query.attendance
        );
        this.attendance = found ? { ...found } : null;
      } else {
        this.attendance = null;
      }

      if (query.classrooms) {
        this.selectedClassrooms = Number(query.classrooms);
        if (this.classrooms.length) {
          this.classroom = this.classrooms.find(
            (c) => c.id === this.selectedClassrooms
          ) || null;
        }
      } else {
        this.selectedClassrooms = null;
        this.classroom = null;
      }

      this.startDateFilter = query.startDate || null;
      this.endDateFilter = query.endDate || null;

      if (query.registerPlace) {
        const id = Number(query.registerPlace);
        const found = this.qrcodeUsers.find((u) => u.id === id);
        this.registerPlace = found || id;
      } else {
        this.registerPlace = null;
      }
    },

    callbackCycles(selected) {
      this.cycle = selected.id !== -1 ? selected.id : null;
      this.classroom = null;
      this.selectedClassrooms = null;
      this.page = 1;
      this.getClassrooms();
      this.getAttendanceList();
    },

    getClassrooms() {
      const params = {
        yearsback: this.cycle ? 0 : 1,
      };

      if (this.cycle) {
        params.cycleId = this.cycle;
      }

      DataServiceClassrooms.index(params)
        .then((response) => {
          this.classrooms = response.data.classrooms;

          if (this.classrooms.length) {
            this.classrooms = this.classrooms.map((classroom) => {
              return {
                id: classroom.id,
                designation: classroom.designation,
                calendar_id: classroom.calendar_id,
              };
            });

            if (this.selectedClassrooms) {
              this.classroom = this.classrooms.find(
                (c) => c.id === this.selectedClassrooms
              ) || null;
            }
          }
        })
        .catch((error) => {
          return error.data;
        });
    },

    exclude(id) {
      this.$swal
        .fire({
          title: "Tem certeza?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await DataService.delete(id);
              this.$swal
                .fire("Excluído!", "Registro foi excluído.", "success")
                .then((response) => {
                  this.getAttendanceList();
                  return response.data;
                });
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel excluir!",
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error.response;
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel excluir!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error.response;
        });
    },

    orderName() {
      this.descOrder = !this.descOrder;
    },

    callbackClassrooms(selected) {
      this.selectedClassrooms = selected.id;
      this.page = 1;
      this.getAttendanceList();
      this.checkClassroomsWithoutAfterHours();
    },

    checkClassroomsWithoutAfterHours() {
      if (!this.selectedClassrooms) return;
      const params = { classroom_ids: [this.selectedClassrooms] };
      httpRda
        .get("/attendances/classrooms-without-after-hours", { params })
        .then((response) => {
          if (response.data.data && response.data.data.length > 0) {
            const classrooms = response.data.data
              .map((c) => `<li>${c.designation}</li>`)
              .join("");

            const plural = response.data.data.length > 1;

            this.$swal.fire({
              icon: "warning",
              title: "Atenção",
              html: `<p>${plural ? "As turmas:" : "A turma:"}</p>
                <ul style="text-align:left">${classrooms}</ul><p style="margin-bottom:0">${
                plural ? "Possuem" : "Possui"
              } registros de falta em contraturno, mas não ${
                plural ? "possuem" : "possui"
              } horário de contraturno cadastrado. Isso pode ocasionar erros ao gerar os relatórios.</p>`,
              confirmButtonColor: "#68c5b7",
              confirmButtonText: "OK",
            });
          }
        })
        .catch((error) => {
          return error;
        });
    },

    callbackRemoveClassrooms() {
      this.selectedClassrooms = null;
      this.page = 1;
      this.getAttendanceList();
    },

    async submitAllStudents() {
      let currentTzOffset = moment().utcOffset();
      currentTzOffset = Math.abs(currentTzOffset / 60);

      let customDate = this.attendanceDate;

      customDate = moment(this.attendanceDate)
        .add(currentTzOffset > 0 ? 1 : 0, "day")
        .format("YYYY-MM-DD");

      this.attendanceDate = moment
        .tz(
          customDate + " " + this.timeModal,
          "YYYY-MM-DD HH:mm",
          "America/Sao_Paulo"
        )
        .utc();

      this.studentsModal = this.studentsModal.map((student) => {
        return {
          ...student,
          type: student.type.value,
          period: student.period.id,
          date: this.attendanceDate,
        };
      });

      httpRda
        .post("/attendances/students", this.studentsModal)
        .then(() => {
          this.$bvModal.hide("modal-att-class");
          this.clearFieldsModal();
          this.getAttendanceList();
          this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });
          this.$swal.fire({
            icon: "success",
            title: "Presença marcada com sucesso!",
          });
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.error,
            footer: "Por favor, tente novamente mais tarde.",
          });
        });
    },

    getModalData() {
      this.studentsModal = httpRda
        .get(
          `/students?include=cycle&search=&classroom=${this.selectedClassroomsModal.join()}&only_active=true`
        )
        .then((response) => {
          this.studentsModal = response.data.students;
          this.studentsModal = this.studentsModal.map((student) => {
            return {
              student_id: student.id,
              name: student.User.name,
              classroom_id: student.classroom_id ? student.classroom_id : null,
              calendar_id:
                this.classrooms.find(
                  (classroom) => classroom.id === student.classroom_id
                ).calendar_id || null,
              type: {
                id: "presence",
                value: "presence",
                name: "Presença",
              },
              period: {
                id: "regular",
                label: "Horário regular",
              },
            };
          });
        });
    },

    callbackRemoveClassroomsModal({ id }) {
      this.selectedClassroomsModal = this.selectedClassroomsModal.filter(
        (classroom) => classroom !== id
      );
      this.studentsModal = [];
      this.getModalData();
    },

    callbackClassroomsModal(element) {
      this.selectedClassroomsModal.push(element.id);
      this.getModalData();
    },

    callbackAttendances(option) {
      this.attendance = option || null;
      this.page = 1;
      this.getAttendanceList();
    },

    callbackAttendancesPlaces({ id }) {
      this.registerPlace = id !== -1 ? id : null;
      this.page = 1;
      this.getAttendanceList();
    },

    callbackAttendancesModal(value, index) {
      this.studentsModal[index].type = value;
    },

    callbackGeraltEventModal(value) {
      this.geralTypeModal = value;

      this.studentsModal = this.studentsModal.map((student) => {
        return {
          ...student,
          type: value,
        };
      });
    },

    callbackGeraltTypeModal(value) {
      this.generalPeriodModel = value;

      this.studentsModal = this.studentsModal.map((student) => {
        return {
          ...student,
          period: value,
        };
      });
    },

    changePage(page) {
      this.page = page;
      this.getAttendanceList();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    clearSearchTitle() {
      this.searchTitle = "";
      this.page = 1;
      this.getAttendanceList();
    },

    clearFields() {
      this.searchTitle = "";
      this.attendance = null;
      this.classroom = null;
      this.selectedClassrooms = null;
      this.page = 1;
      this.registerPlace = null;
      this.startDateFilter = null;
      this.endDateFilter = null;
      this.cycle = null;

      this.getClassrooms();
      this.getAttendanceList();
    },

    clearFieldsModal() {
      this.classroomModal = [];
      this.selectedClassroomsModal = [];
      this.studentsModal = [];
      this.attendanceDate = "";
      this.timeModal = moment().format("HH:mm").toString();
      this.geralTypeModal = {
        id: "presence",
        value: "presence",
        name: "Presença",
      };
      this.generalPeriodModel = {
        id: "regular",
        label: "Horário regular",
      };
    },

    validationForReport() {
      if (!this.selectedClassrooms) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Selecione uma turma para exportar o relatório!",
          footer: "",
        });
        return false;
      }
      return true;
    },

    async generateReport() {
      try {
        if (this.validationForReport()) {
          this.generatingReport = true;
          const ts = moment().valueOf();
          const params = btoa(JSON.stringify(this.paramsReport));
          httpRda
            .get(
              "/attendances/data-report/token?ts=" + ts + "&params=" + params
            )
            .then((response) => {
              const token = response.data.token;

              const link = document.createElement("a");
              link.target = "_blank";
              link.href = `${process.env.VUE_APP_URL}attendances/data-report?token=${token}&ts=${ts}&params=${params}`;
              link.click();
            })
            .finally(() => {
              this.generatingReport = false;
            });

          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: `Relatório exportado com sucesso!`,
          });

          return true;
        }
      } catch (error) {
        this.generatingReport = false;
        this.loadText = "Exportar";
        this.subjectsSelected = [];

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possivel exportar o relatório!",
          footer: "Por favor, tente novamente mais tarde.",
        });

        return error;
      }
    },

    async generateReportAudit() {
      try {
        if (this.validationForReport()) {
          this.generatingReportAudit = true;
          const ts = moment().valueOf();
          const params = btoa(JSON.stringify(this.paramsReport));

          await httpRda
            .get(
              "/attendances/data-report/token?ts=" + ts + "&params=" + params
            )
            .then((response) => {
              const token = response.data.token;

              const link = document.createElement("a");
              link.target = "_blank";
              link.href = `${process.env.VUE_APP_URL}attendances/data-report-for-audit?token=${token}&ts=${ts}&params=${params}`;
              link.click();
            })
            .finally(() => {
              this.generatingReportAudit = false;
            });

          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: `Relatório exportado com sucesso!`,
          });

          return true;
        }
      } catch (error) {
        this.generatingReportAudit = false;
        this.loadText = "Exportar";
        this.subjectsSelected = [];

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possivel exportar o relatório!",
          footer: "Por favor, tente novamente mais tarde.",
        });

        return error;
      }
    },

    async downloadAbsenceLimitReport() {
      if (!this.cycle) {
        return;
      }

      this.downloadingAbsenceLimitReport = true;

      try {
        const response = await httpRda.get(
          "/attendances/absence-limit-report",
          {
            params: {
              cycle_id: this.cycle,
              classroom_id: this.selectedClassrooms || undefined,
            },
            responseType: "blob",
          }
        );

        const disposition = response.headers["content-disposition"];
        const match =
          disposition && disposition.match(/filename="?([^"]+)"?/);
        const fileName = match ? match[1] : "relatorio-limite-de-faltas.xlsx";

        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");

        link.href = url;
        link.download = fileName;
        link.click();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        let details = "Não foi possível gerar o relatório.";

        if (error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            details = JSON.parse(text).details || details;
          } catch (parseError) {
            // mantém a mensagem padrão
          }
        }

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: details,
          footer: "",
        });
      } finally {
        this.downloadingAbsenceLimitReport = false;
      }
    },

    upload() {
      //this.currentFile = this.filecsv
      DataService.uploadCSV(this.filecsv)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          this.currentFile = undefined;
          return error.data;
        });

      this.filecsv = undefined;
    },

    submitFile() {
      const [file] = this.file;
      const bodyFormData = new FormData();

      bodyFormData.append("file", file);

      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        title: "Carregando, por favor... Aguarde",
      });

      try {
        DataService.uploadCSV({
          file: bodyFormData,
        });
        this.getAttendanceList();
        this.$swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "success",
          title: "Planilha enviada com sucesso!",
        });
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possivel importar!",
          footer: "Por favor, tente novamente mais tarde.",
        });
      }
    },

    getQrCodeUsers() {
      httpRda.get("/collaborator/qrcode-users").then((response) => {
        this.qrcodeUsers = response.data.users;
        this.qrcodeUsers.unshift({
          id: -1,
          name: "Todos",
        });

        const queryRegisterPlace = this.$route.query.registerPlace;
        if (queryRegisterPlace) {
          const id = Number(queryRegisterPlace);
          const found = this.qrcodeUsers.find((u) => u.id === id);
          if (found) {
            this.registerPlace = found;
          }
        }
      });
    },

    redirectToCorrectUrl(url) {
      if (
        this.currentUser.role &&
        this.currentUser.role.includes("attendance_manager")
      ) {
        return "registro-" + url;
      } else {
        return url;
      }
    },
  },

  watch: {
    "$route.query": {
      handler() {
        if (this.isInternalNavigation) {
          this.isInternalNavigation = false;
          return;
        }
        this.syncFiltersFromQuery();
        this.getAttendanceList();
      },
    },

    page() {
      this.getAttendanceList();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },

  created() {
    const query = this.$route.query;

    this.searchTitle = query.search || "";
    this.page = Number(query.page) || 1;

    if (query.cycle) {
      this.cycle = Number(query.cycle);
    }

    if (query.attendance) {
      const found = ATTENDANCE_OPTIONS.find(
        (o) => o.value === query.attendance
      );
      this.attendance = found ? { ...found } : null;
    }

    if (query.classrooms) {
      this.selectedClassrooms = Number(query.classrooms);
    }

    if (query.startDate) {
      this.startDateFilter = query.startDate;
    }

    if (query.endDate) {
      this.endDateFilter = query.endDate;
    }

    if (query.registerPlace) {
      this.registerPlace = Number(query.registerPlace);
    }

    this.getQrCodeUsers();
    this.getClassrooms();
  },

  mounted() {
    this.getAttendanceList();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.label-add {
  text-indent: -999rem;
  font-size: 0;
}
.home {
  height: 100%;
}

.text-align {
  text-align: center;
}

.action-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  a,
  svg {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: opacity 0.2s ease, transform 0.2s ease;

    &:hover {
      opacity: 0.75;
      transform: scale(1.08);
    }
  }
}

.tags {
  background-color: $blue;
  border-radius: 5px;
  color: $white;
  font-weight: $bold;
  line-height: 28px;
  margin: 3px 12px 3px 0;
  max-width: 58px;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  width: 100%;
}

.classroom {
  border-radius: 5px;
  display: inline-block;
  color: $white;
  font-weight: 700;
  line-height: 28px;
  min-width: 110px;
  max-width: 100%;
  padding: 0 8px;
  text-align: center;
  background-color: $blue;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.old-classroom {
  background-color: #d4870e;
}

.attendance {
  border-radius: 5px;
  display: inline-block;
  color: $white;
  font-weight: 700;
  line-height: 28px;
  min-width: 110px;
  max-width: 100%;
  padding: 0 8px;
  text-align: center;
  white-space: nowrap;

  &.late {
    background-color: $orange;
  }
  &.absence {
    background-color: $red;
  }
  &.presence {
    background-color: $green2;
  }
  &.antecipated {
    background-color: $purple;
  }
  &.regular_leave {
    background-color: $yellow;
  }
}

.attendance-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px !important;
}

.report-btn {
  flex: 0 0 auto !important;
  width: max-content !important;
  max-width: none !important;
  min-width: 260px !important;
  white-space: nowrap !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  margin: 0 !important;
}
</style>
